import {Dispatch} from "redux";
import {ErrorDto} from "../../models/dtos/error.dto";
import {API_ERROR_RESET, API_ERROR_SET} from "./constants";
import {ApiErrorResetAction, ApiErrorSetAction} from "./types";

export const apiErrorSetAction = (payload: ErrorDto): ApiErrorSetAction => {
  return {
    type: API_ERROR_SET,
    payload: payload,
  };
}
const apiErrorResetAction = (): ApiErrorResetAction => {
  return {
    type: API_ERROR_RESET,
  };
}

export const apiErrorSet = (error: ErrorDto) => async (
  dispatch: Dispatch
) => {
  dispatch(apiErrorSetAction(error));
};

export const apiErrorReset = () => async (
  dispatch: Dispatch
) => {
  dispatch(apiErrorResetAction());
};
